import { render } from "./CompanyAgreementSendingConfiguration.vue?vue&type=template&id=035d564c"
import script from "./CompanyAgreementSendingConfiguration.vue?vue&type=script&lang=js"
export * from "./CompanyAgreementSendingConfiguration.vue?vue&type=script&lang=js"

import "./CompanyAgreementSendingConfiguration.vue?vue&type=style&index=0&id=035d564c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__